export default function(next, store) {
  if(!store.state.isLoggedIn) {
    next({ name: 'About' })
  } else {
    next()
  }
}